import { CesiumContentHeader } from './types';

export const cesiumContentHeaderSize = 28;
const cesiumContentHeaderOffset: CesiumContentHeader = {
  versionId: 4,
  byteLength: 8,
  featureTableJSONLength: 12,
  featureTableBinaryByteLength: 16,
  batchTableJSONByteLength: 20,
  batchTableBinaryByteLength: 24,
};

/**
 *  Extracts header values from specified buffer using the header buffer offset.
 */
export const extractCesiumContentHeader = (cesiumBuffer: ArrayBuffer): CesiumContentHeader => {
  const dataView = new DataView(cesiumBuffer);
  return {
    versionId: dataView.getUint32(cesiumContentHeaderOffset.versionId, true),
    byteLength: dataView.getUint32(cesiumContentHeaderOffset.byteLength, true),
    featureTableJSONLength: dataView.getUint32(
      cesiumContentHeaderOffset.featureTableJSONLength,
      true,
    ),
    featureTableBinaryByteLength: dataView.getUint32(
      cesiumContentHeaderOffset.featureTableBinaryByteLength,
      true,
    ),
    batchTableJSONByteLength: dataView.getUint32(
      cesiumContentHeaderOffset.batchTableJSONByteLength,
      true,
    ),
    batchTableBinaryByteLength: dataView.getUint32(
      cesiumContentHeaderOffset.batchTableBinaryByteLength,
      true,
    ),
  };
};
